import Entity from '../entity'
export default class EstadoEnvioOzone extends Entity<number>{
    nombre: string
}